<template>
    <div>
        <v-dialog
          v-model="dialog1"
          max-width="500"
        >
            <v-card>
                <v-card-title class="headline d-flex justify-center">
                    1 Last Step to Go!
                </v-card-title>
                <v-card-text>
                    <v-row v-if="isloginless" justify="center">
                        <v-col lg=12>
                            <v-form>
                                <v-stepper v-model="e1"> 
                                    <v-stepper-header>
                                        <v-stepper-step :complete="e1 > 1" step="1">Contact Details</v-stepper-step>
                                        <v-divider></v-divider>
                                        <v-stepper-step :complete="e1 > 2" step="2">Delivery Address</v-stepper-step>
                                    </v-stepper-header>
                                    <v-stepper-items>
                                        <v-stepper-content step="1">
                                            <v-form ref="form1">
                                                <v-text-field v-model="name" :rules="[rules.required]" label='Full Name' solo dense></v-text-field>
                                                <v-text-field v-model="phone" :rules="[rules.required]" label='Phone' solo dense></v-text-field>
                                                <v-text-field v-model="email" :rules="[rules.required]" label='Email' solo dense></v-text-field>
                                                <v-btn class='mb-5' block color="primary" @click="submitForm1">
                                                    Next
                                                </v-btn>
                                            </v-form>
                                        </v-stepper-content>
                                        <v-stepper-content step="2">
                                            <v-form ref="form2">
                                                <v-text-field v-model="address1" :rules="[rules.required]" label='Address Line 1' solo dense></v-text-field>
                                                <v-text-field v-model="address2" label='Address Line 2' solo dense></v-text-field>
                                                <v-text-field v-model="city" :rules="[rules.required]" label='City' solo dense></v-text-field>
                                                <v-text-field v-model="state" :rules="[rules.required]" label='State' solo dense></v-text-field>
                                                <v-text-field v-model="pincode" :rules="[rules.required]" label='PIN Code' solo dense></v-text-field>
                                                <v-btn class='mb-5' block color="primary" @click="submitForm2">
                                                    Checkout
                                                </v-btn>
                                            </v-form>
                                        </v-stepper-content>
                                    </v-stepper-items>
                                </v-stepper>
                            </v-form>
                        </v-col>
                    </v-row>
                    <v-row justify='center' v-else>
                        <v-col lg=8>
                            <v-img :src="require('../assets/checkout_modal.svg')" contain/>
                        </v-col>
                    </v-row>
                </v-card-text>

                <v-card-actions v-if="!isloginless" class='pl-10 pr-10 d-flex justify-center flex-column'>
                    <v-btn @click="login" class='mb-5' block color="primary"> Login</v-btn>
                    <a class='mb-2' @click='isloginless=true'>Skip Login</a>
                </v-card-actions>
                <v-card-actions v-else class='pl-10 pr-10 d-flex justify-center flex-column'>
                    <a class='mb-2' @click='login'>Login Instead</a>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-container class='pt-15'>
            <v-row justify='space-between'>
                <v-card height=500 width=500>
                   <v-img height=500 width=500 :src="productImg"></v-img>
                </v-card>
                <div class='product_details pl-5 pt-5'>
                    <p class='mb-0'>Product Name:</p>
                    <h1>{{productName}}</h1>
                    <p class='mt-5'>Product Description</p>
                    <p class='mb-0'>Price</p>
                    <h2>Rs. {{productPrice}}</h2>
                    <h3 class='success--text mt-2 mb-8'>In Stock</h3>
                    <!-- <p>Quantity</p>
                        <v-select
                        dense
                        class='qty_wrapper mb-0' 
                        @change="showAddCart=true"
                        :items="items"
                        v-model="qty"
                        solo
                        ></v-select> -->
                    
                    <v-btn color='success' v-show="showAddCart" @click="addCart" width=300 height=45>Add to cart <v-icon right>mdi-cart-plus</v-icon></v-btn>
                    <v-btn color='success' v-show="!showAddCart" @click="goCart" width=300 height=45>Go to cart </v-btn>
                    <br>
                    <v-btn class='mt-5' v-show="showBuyNow" color='primary' width=300 height=45 @click="buyNow">Buy Now <v-icon right>mdi-arrow-right</v-icon></v-btn>
                </div>
            </v-row>
            <div v-if='false'>
                <h2 class='mt-5 mb-5'>Similar Products</h2>
                <v-row class='mb-10'>
                    <v-card height=200 width=200 class='ml-3'></v-card>
                    <v-card height=200 width=200 class='ml-3'></v-card>
                    <v-card height=200 width=200 class='ml-3'></v-card>
                </v-row>
            </div>
            
        </v-container>
    </div>
</template>
<style scoped>
.qty_wrapper
{
    width:150px;
}
    .container
    {
        margin-top:60px;
    }
    .product_details
    {
        width:600px;
    }
</style>
<script>

/*global myBaseURL*/
import axios from 'axios';

export default {
    name:'ProductPage',
     data(){
        return{
            storeName:'Store',
            productName:'',
            productImg:'',
            productPrice:0,
            productVariant: 0,
            qty:1,
            // bannerImage:'',
            storeLogo:'',
            items:[1,2,3],
            unique_id: '',
            cart : [],
            showAddCart : true,
            showBuyNow : false,
            dialog1 : false,
            name : '',
            email : '',
            phone : '',
            address1 : '',
            address2 : '',
            city : '',
            state : '',
            pincode : '',
            e1: 1,
            isloginless:false,
            rules:{
                required: value => !!value || 'Required.',
                counter: value => value.length <= 25 || 'Max 25 characters',
            },
        }
    },
    created(){
        this.unique_id = window.localStorage.getItem('unique_id')
        this.$emit('showAppBar');
        var that = this;
        axios.request({
            url: '/store/home/'+this.$route.params.store_slug,
            method: 'GET',
            baseURL: myBaseURL,
            // headers: {
            //     'Authorization': 'Bearer '+ window.localStorage.access_token
            // }
        }).then(response => {
            this.$emit('showLogo',response.data.logo,response.data.slug);

            axios.request({
                url: '/store/product/' + that.$route.params.product_id,
                method: 'GET',
                baseURL: myBaseURL,
                // headers: {
                //     'Authorization': 'Bearer '+ window.localStorage.access_token
                // }
            }).then(response => {
                console.log(response.data);
                that.productName=response.data.name;
                that.productVariant = response.data.product_variants[0].id
                that.productImg=response.data.product_variants[0].image
                that.productPrice=response.data.product_variants[0].price
                
                if(that.unique_id && that.unique_id != '')
                {
                    console.log('edit');
                    axios.request({
                        url: '/cart/'+ that.$route.params.store_slug + '/' + that.unique_id,
                        method: 'GET',
                        baseURL: myBaseURL
                        // headers: {
                        //     'Authorization': 'Bearer '+ window.localStorage.access_token
                        // }
                    }).then(response => {
                        console.log(response.data);
                        that.cart = response.data.cart.cart_items;
                        var objIndex = that.cart.findIndex((obj => obj.variant == that.productVariant));
                        if(objIndex >= 0)
                        {
                            that.showAddCart = false;
                        }
                        else
                        {
                            that.showAddCart = true;
                        }
                        that.showBuyNow = false;
                    }).catch(e => {
                        console.log(e)
                        that.showBuyNow = true;
                    });
                }
                else
                {
                    that.showBuyNow = true;
                }
            }).catch(e => {
                console.log(e)
            })
        }).catch(e => {
            console.log(e)
        })
    },
    methods : {
        login()
        {
            this.$router.push({ path: '/' + this.$route.params.store_slug + '/login', query: { redirect: '/' + this.$route.params.store_slug + '/cart' }  })
        },
        goCart()
        {
            this.$router.push({ path: '/' + this.$route.params.store_slug + '/cart' })
        },
        addCart(){
            var that = this;
            that.unique_id = window.localStorage.getItem('unique_id')
            var objIndex = that.cart.findIndex((obj => obj.variant == that.productVariant));
            if(objIndex >= 0)
            {
                that.cart[objIndex].qty = that.qty;
            }
            else
            {
                that.cart.push({
                    'product' : that.$route.params.product_id,
                    'variant' : that.productVariant,
                    'qty' : that.qty
                })
            }
            
            axios.request({
                url: '/cart/',
                method: 'POST',
                baseURL: myBaseURL,
                data : {
                    'store_slug' : that.$route.params.store_slug,
                    'unique_id' : that.unique_id,
                    'cart_items' : that.cart,
                }
            }).then(response => {
                console.log(response.data);
                window.localStorage.setItem('unique_id', response.data.unique_id);
                window.localStorage.setItem('store_slug', response.data.store_slug);
                that.showAddCart = false;
                that.showBuyNow = false;
                console.log('Success Data');
            }).catch(e => {
                console.log(e);
                console.log('Fail Data');
            });
        },
        buyNow()
        {
            var that = this;
            
            that.unique_id = window.localStorage.getItem('unique_id');
            var objIndex = that.cart.findIndex((obj => obj.variant == that.productVariant));
            if(objIndex >= 0)
            {
                that.cart[objIndex].qty = that.qty;
            }
            else
            {
                that.cart.push({
                    'product' : that.$route.params.product_id,
                    'variant' : that.productVariant,
                    'qty' : that.qty
                })
            }
            
            axios.request({
                url: '/cart/',
                method: 'POST',
                baseURL: myBaseURL,
                data : {
                    'store_slug' : that.$route.params.store_slug,
                    'unique_id' : that.unique_id,
                    'cart_items' : that.cart,
                }
            }).then(response => {
                console.log(response.data);
                if(response.data.status == true)
                {
                    window.localStorage.setItem('unique_id', response.data.unique_id);

                    that.unique_id = window.localStorage.getItem('unique_id');
                    var token = window.localStorage.getItem('access_token');
                    
                    if(token)
                    {
                        axios.request({
                            url: '/checkCustomerToken/' + that.$route.params.store_slug,
                            method: 'GET',
                            baseURL: myBaseURL,
                            headers: {
                                'Authorization': 'Bearer '+ token
                            }
                        }).then(response => {
                            console.log(response.data);
                            if(response.data.token)
                            {
                                that.customer_id = response.data.customer_id;
                                window.location.href = myBaseURL + '/order/create/' + that.$route.params.store_slug + '/' + that.unique_id + '/' + that.customer_id;
                            }
                        }).catch(e => {
                            console.log(e)
                            that.dialog1 = true;
                        })
                    }
                    else
                    {
                        that.dialog1=true;
                    }
                }
                else
                {
                    window.localStorage.setItem('unique_id', '');
                    this.$router.push({ name: 'Store', params : {store_slug : this.$route.params.store_slug } })
                }
                console.log('Success Data');
            }).catch(e => {
                console.log(e);
                console.log('Fail Data');
            });
        },
        submitForm1()
        {
            if(this.$refs.form1.validate())
            {
                this.e1=2;
            }
        },
        submitForm2()
        {
            var that = this;
            if(this.$refs.form2.validate())
            {
                this.unique_id = window.localStorage.getItem('unique_id');
                axios.request({
                    url: '/loginless/customer/details/' + that.$route.params.store_slug,
                    method: 'POST',
                    baseURL: myBaseURL,
                    data : {
                        'name' : that.name,
                        'email' : that.email,
                        'phone' : that.phone,
                        'address1' : that.address1,
                        'address2' : that.address2,
                        'city' : that.city,
                        'state' : that.state,
                        'pincode' : that.pincode,
                        'unique_id' : that.unique_id
                    }
                }).then(response => {
                    console.log(response.data);
                    console.log('Success Data');
                    that.customer_id = response.data.id;
                    
                    window.location.href = myBaseURL + '/order/create/' + that.$route.params.store_slug + '/' + that.unique_id + '/' + response.data.id;
                    
                }).catch(e => {
                    console.log(e);
                    console.log('Fail Data');
                });
            }
        }
    }
}
</script>